export default function initIframeResizer(): void {
  import('iframe-resizer/js/iframeResizer.contentWindow').then(() => {
    console.log(
      'Support for the iframe has been initialized. See also the docs: https://github.com/davidjbradshaw/iframe-resizer',
    );
  });
}
